import React, { useEffect, useState } from "react";
import CardWrapper from "@/components/card/CardWrapper";
import { Col, Flex, Form, Row, Select } from "antd";
import { Link, useNavigate } from "react-router-dom";
import ButtonComponent from "@/components/button/Button";
import IconCross from "@/components/icons/IconCross";
import { getAllCountries } from "@/services/common/getAllCountries";
import { getRegionByCountry } from "@/services/common/getRegionByCountry";
import { getLevels } from "@/services/common/getLevels";
import { getDisciplines } from "@/services/common/getDisciplines";
import { getUniversityByCountryAndRegion } from "@/services/common/getUniversityByCountryAndRegion";
import "@/styles/pages/guide/guideForm.scss";
import { getUserPreferences } from "@/services/users/getUserPreferences";
import { useDispatch, useSelector } from "react-redux";
import { getIsLoggedIn, getUserInfo, setModalOpen } from "@/reducers/commonSlice";
import { getIsCheckoutToShow } from "@/reducers/checkoutSlice";
import getCountryISO2 from "@/lib/data/isoThreeToTwo";

// const regionOptions = [
//   {
//     value: "south-america",
//     label: "South America",
//   },
//   {
//     value: "north-america",
//     label: "North America",
//   },
//   {
//     value: "texas",
//     label: "Texas",
//   },
//   {
//     value: "sydney",
//     label: "Sydney",
//   },
// ];

// const levelOptions = [
//   {
//     value: "ug",
//     label: "UG",
//   },
//   {
//     value: "pg",
//     label: "PG",
//   },
//   {
//     value: "phd",
//     label: "PHD",
//   },
//   {
//     value: "master",
//     label: "Master",
//   },
// ];

// const disciplineOptions = [
//   {
//     value: "computer-science",
//     label: "Computer Science",
//   },
//   {
//     value: "micro-biology",
//     label: "Micro Biology",
//   },
// ];

// const universityOptions = [
//   {
//     value: "GMIT",
//     label: "GMIT",
//   },
//   {
//     value: "texas-university",
//     label: "Texas University",
//   },
//   {
//     value: "dallas-university",
//     label: "Dallas University",
//   },
// ];

// Filter `option.label` match the user type `input`
const filterOption = (input, option) => {
  console.log(input, option);
  return (option?.key ?? "").toLowerCase().includes(input.toLowerCase());
};

const customizeRequiredMark = (label, { required }) => (
  <>
    {label}
    {required && <span style={{ color: "red" }}>*</span>}
  </>
);

const GuideForm = ({ handleFinish, title, subtitle, isOnBoarding, className, initialValues }) => {
  const dispatch = useDispatch();

  const [countryList, setCountryList] = useState([]);
  const [regionOptions, setRegionOption] = useState([]);
  const [levelOptions, setLevelOptions] = useState([]);
  const [disciplineOption, setDisciplineOptions] = useState([]);
  const [universityOptions, setUniverityOption] = useState([]);
  const [selectedCountry, setSelectedCountry] = useState();
  const [selectedRegion, setSelectedRegion] = useState();
  const [selectedLevel, setSelectedLevel] = useState();
  const [selectedDiscipline, setSelectedDiscipline] = useState();
  const [selectedUniversity, setSelectedUniversity] = useState();
  const isCheckoutToShow = useSelector(getIsCheckoutToShow);
  const userData = useSelector(getUserInfo);
  const isLoggedIn = useSelector(getIsLoggedIn);
  const [form] = Form.useForm();

  useEffect(() => {
    if (initialValues) {
      form.setFieldsValue({
        countryCode: initialValues.country?.code,
        regionIds: initialValues.regions?.map((x) => x.id),
        levelIds: initialValues.levels?.map((x) => x.id),
        disciplineIds: initialValues.disciplines?.map((x) => x.id),
        universityIds: initialValues.universities?.map((x) => x.id),
      });

      setSelectedCountry(initialValues.country?.code);
      setSelectedRegion(initialValues.regions?.map((x) => x.id));
      setSelectedLevel(initialValues.levels?.map((x) => x.id));
      setSelectedDiscipline(initialValues.disciplines?.map((x) => x.id));
      setSelectedUniversity(initialValues.universities?.map((x) => x.id));
    }
  }, [initialValues, form]);

  const tagRender = (props) => {
    const { label, value, closable, onClose } = props;
    const onPreventMouseDown = (event) => {
      event.preventDefault();
      event.stopPropagation();
    };

    return label?.length ? (
      <div className="selected-chip" onMouseDown={onPreventMouseDown}>
        <span>{label}</span> <IconCross style={{ cursor: "pointer" }} onClick={onClose} />
      </div>
    ) : (
      <></>
    );
  };

  const { Option } = Select;
  const navigate = useNavigate();

  const fetchCountryData = () => {
    getAllCountries()
      .then((response) => {
        setCountryList(
          response?.map((x) => ({
            ...x,
            flag:
              x.code !== "0"
                ? `https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/${getCountryISO2(
                    x.code
                  )}.svg`
                : "/assets/images/otherFlag.png",
          }))
        );
      })
      .catch((error) => console.log(error));
  };

  const fetchLevels = () => {
    getLevels().then((response) => {
      const sortedLevels = response
        ?.map((x) => ({ label: x.name, value: x.id }))
        .sort((a, b) => a.label.localeCompare(b.label));
      setLevelOptions(sortedLevels);
    });
  };

  const fetchDiscipline = () => {
    getDisciplines().then((response) => {
      const sortedDisciplines = response
        ?.map((x) => ({ label: x.name, value: x.id }))
        .sort((a, b) => a.label.localeCompare(b.label));
      setDisciplineOptions(sortedDisciplines);
    });
  };

  useEffect(() => {
    fetchCountryData();
    fetchLevels();
    fetchDiscipline();
  }, []);

  const fetchRegionData = () => {
    getRegionByCountry(selectedCountry)
      .then((response) => {
        setRegionOption([]);
        setSelectedRegion([]);
        setRegionOption(response?.map((x) => ({ label: x.name, value: x.id })));
        // form.resetFields(["regionIds", "universityIds"]);
        // form.resetFields(["regionIds", "universityIds"]);
        // form.resetFields([""]);
        // form.setFieldsValue({
        //   regionIds: [],
        //   universityIds: [],
        // });
        setSelectedUniversity([]);
        setUniverityOption([]);
      })
      .catch((error) => console.log(error));
  };

  const fetchUniversity = () => {
    if (selectedCountry && selectedRegion) {
      getUniversityByCountryAndRegion(selectedCountry, selectedRegion)
        .then((response) => {
          const sortedUniversities = response
            ? response.sort((a, b) => a.name.localeCompare(b.name))
            : [];
          setUniverityOption(sortedUniversities.map((x) => ({ label: x.name, value: x.id })));
        })
        .catch((error) => console.log(error));
    }
  };

  useEffect(() => {
    if (selectedCountry?.length) {
      fetchRegionData();
    }
  }, [selectedCountry]);

  useEffect(() => {
    fetchUniversity();
  }, [selectedRegion]);

  useEffect(() => {
    console.log("isLoggedIn changed:", isLoggedIn);
    console.log("userData changed:", userData);
  }, [isLoggedIn, userData]);

  const fetchData = () => {
    getUserPreferences()
      .then((res) => {
        setSelectedCountry(res.country.code);
        setSelectedRegion(res.regions?.map((x) => x.id));
        setSelectedLevel(res.levels?.map((x) => x.id));
        setSelectedDiscipline(res.disciplines?.map((x) => x.id));
        setSelectedUniversity(res.universities?.map((x) => x.id));
        form.setFieldsValue({
          countryCode: res.country.code,
          regionIds: res.regions?.map((x) => x.id),
          levelIds: res.levels?.map((x) => x.id),
          disciplineIds: res.disciplines?.map((x) => x.id),
          universityIds: res.universities?.map((x) => x.id),
        });
      })
      .catch((err) => console.log(err));
  };

  useEffect(() => {
    fetchData();
  }, []);

  return (
    <CardWrapper className={`guide-form-card ${className}`}>
      <div className="guide-header">
        <div className="title-h6">{title}</div>
        <div className="body-b3">{subtitle}</div>
      </div>
      <div className="guide-filter">
        <Form
          name="searchGuide"
          initialValues={{
            remember: true,
            countryCode: selectedCountry,
            regionIds: selectedRegion,
            levelIds: selectedLevel,
            disciplineIds: selectedDiscipline,
            universityIds: selectedUniversity,
          }}
          layout="vertical"
          form={form}
          onFinish={handleFinish}
          requiredMark={!isOnBoarding && customizeRequiredMark}
        >
          <Row justify="center" gutter={[16, 0]}>
            <Col xs={24} md={12}>
              <Form.Item
                label="Preferred Country"
                name="countryCode"
                rules={[
                  {
                    required: true,
                    message: "Please select Preferred Country",
                  },
                ]}
              >
                <Select
                  virtual={false}
                  showSearch
                  placeholder="Select a Preferred Country"
                  className="w-100"
                  onChange={(value) => {
                    form.setFieldsValue({ regionIds: [], universityIds: [] });
                    setSelectedCountry(value);
                  }}
                  filterOption={filterOption}
                >
                  {countryList.map((country) => {
                    return (
                      <Option key={country.name} value={country.code} label={country.name}>
                        <Flex justify="start" align="center" gap={"5px"}>
                          <img src={country.flag} height={30} width={30} />
                          <span>{country.name}</span>
                        </Flex>
                      </Option>
                    );
                  })}
                </Select>
              </Form.Item>
            </Col>
            {/* <Col xs={24} md={12}>
              <Form.Item label="Preferred Region" name="regionIds">
                <Select
                virtual={false}
                  mode="multiple"
                  maxTagCount={2}
                  maxCount={4}
                  placeholder="Select a Preferred Region"
                  className="w-100  multiSelect"
                  defaultBg={"#fff5f0"}
                  defaultColor={"#DB5800"}
                  tagRender={tagRender}
                  optionFilterProp="label"
                  options={regionOptions}
                  onChange={(value) => setSelectedRegion(value)}
                />
              </Form.Item>
            </Col> */}
            <Col xs={24} md={12}>
              <Form.Item label="Level" name="levelIds">
                <Select
                  virtual={false}
                  showSearch
                  placeholder="Select a Level"
                  className="w-100"
                  //   onChange={(value) => onChange(value, "level")}
                  // onChange={(value) => setSelectedLevel(value)}
                  filterOption={
                    (input, option) => option.label.toLowerCase().includes(input.toLowerCase()) // Compare input with label
                  }
                >
                  {levelOptions.map((country) => {
                    return (
                      <Option key={country.value} value={country.value} label={country.label}>
                        <div>{country.label}</div>
                      </Option>
                    );
                  })}
                </Select>
              </Form.Item>
            </Col>
            <Col xs={24} md={12}>
              <Form.Item label="Preferred Discipline" name="disciplineIds">
                <Select
                  virtual={false}
                  mode="multiple"
                  maxTagCount={2}
                  maxCount={4}
                  placeholder="Select a Discipline"
                  className="w-100  multiSelect"
                  defaultBg={"#fff5f0"}
                  defaultColor={"#DB5800"}
                  tagRender={tagRender}
                  optionFilterProp="label"
                  options={disciplineOption}
                  //   onChange={(value) => onChange(value, "course")}
                />
              </Form.Item>
            </Col>
            <Col xs={24} md={12}>
              <Form.Item label="Preferred University" name="universityIds">
                <Select
                  virtual={false}
                  mode="multiple"
                  maxTagCount={2}
                  maxCount={4}
                  placeholder="Select a University"
                  className="w-100 multiSelect"
                  defaultBg={"#fff5f0"}
                  defaultColor={"#DB5800"}
                  tagRender={tagRender}
                  optionFilterProp="label"
                  options={universityOptions}
                  //   onChange={(value) => onChange(value, "university")}
                />
              </Form.Item>
            </Col>
          </Row>
          <Row justify="center">
            <Col md={12}>
              <Form.Item>
                <div className="button">
                  <ButtonComponent
                    label={isOnBoarding ? "Continue" : "Find Mentors"}
                    varient="primary"
                    htmlType="submit"
                    className="w-100"
                    disabled={isLoggedIn && !userData?.verified?.email}
                    // onClick={() => navigate("/guide-list")}
                  />
                </div>
                {isLoggedIn && !userData?.verified?.email ? (
                  <p
                    style={{
                      color: "red",
                      fontSize: "16px",
                      fontWeight: "bold",
                      margin: "10px 0",
                    }}
                  >
                    ⚠️ Your email is not verified. Please{" "}
                    <Link
                      to="/profile/basic-contact-information"
                      style={{
                        color: "red",
                        textDecoration: "underline",
                        fontWeight: "bold",
                      }}
                    >
                      verify your email
                    </Link>
                    .
                  </p>
                ) : null}
              </Form.Item>
            </Col>
          </Row>
          {isOnBoarding ? (
            <Row justify="center">
              <Col md={12}>
                <Form.Item>
                  <div className="button">
                    <ButtonComponent
                      label="Skip"
                      varient=""
                      className="w-100"
                      onClick={() => {
                        if (isCheckoutToShow) {
                          navigate("/checkout-preview");
                        } else if (window.location.pathname.includes("membership")) {
                          navigate("/membership");
                        } else {
                          navigate("/dashboard");
                        }
                        dispatch(setModalOpen(false));
                      }}
                    />
                  </div>
                </Form.Item>
              </Col>
            </Row>
          ) : (
            <></>
          )}
        </Form>
      </div>
    </CardWrapper>
  );
};

export default GuideForm;
